var SPACING = 8;
var getForcedPlacement = function (placementFallback, defaultPlacement) {
    if (placementFallback === 'force-top')
        return 'top';
    if (placementFallback === 'force-right')
        return 'right';
    if (placementFallback === 'force-bottom')
        return 'bottom';
    if (placementFallback === 'force-left')
        return 'left';
    return defaultPlacement;
};
export var calculatePositionCoordinates = function (triggerRect, contentHeight, contentWidth, finalPlacement, finalAlignment, matchTriggerWidth, placementFallback, compensateScroll) {
    if (compensateScroll === void 0) { compensateScroll = false; }
    var scrollTop = compensateScroll ? window.scrollY || document.documentElement.scrollTop : 0;
    var scrollLeft = compensateScroll ? window.scrollX || document.documentElement.scrollLeft : 0;
    var top = 0;
    var left = 0;
    if (finalPlacement === 'top') {
        top = triggerRect.top + scrollTop - contentHeight - SPACING;
        if (finalAlignment === 'start') {
            left = triggerRect.left + scrollLeft;
        }
        else if (finalAlignment === 'end') {
            left = triggerRect.right + scrollLeft - contentWidth;
        }
        else {
            left = triggerRect.left + scrollLeft + (triggerRect.width - contentWidth) / 2;
        }
    }
    else if (finalPlacement === 'bottom') {
        top = triggerRect.bottom + scrollTop + SPACING;
        if (finalAlignment === 'start') {
            left = triggerRect.left + scrollLeft;
        }
        else if (finalAlignment === 'end') {
            left = triggerRect.right + scrollLeft - contentWidth;
        }
        else {
            left = triggerRect.left + scrollLeft + (triggerRect.width - contentWidth) / 2;
        }
    }
    else if (finalPlacement === 'left') {
        left = triggerRect.left + scrollLeft - contentWidth - SPACING;
        if (finalAlignment === 'start') {
            top = triggerRect.top + scrollTop;
        }
        else if (finalAlignment === 'end') {
            top = triggerRect.bottom + scrollTop - contentHeight;
        }
        else {
            top = triggerRect.top + scrollTop + (triggerRect.height - contentHeight) / 2;
        }
    }
    else if (finalPlacement === 'right') {
        left = triggerRect.right + scrollLeft + SPACING;
        if (finalAlignment === 'start') {
            top = triggerRect.top + scrollTop;
        }
        else if (finalAlignment === 'end') {
            top = triggerRect.bottom + scrollTop - contentHeight;
        }
        else {
            top = triggerRect.top + scrollTop + (triggerRect.height - contentHeight) / 2;
        }
    }
    // Prevent going off-screen only if not forced
    if (placementFallback === 'auto') {
        if (left < 0)
            left = 0;
        if (top < 0)
            top = 0;
        if (left + contentWidth > document.documentElement.clientWidth) {
            left = document.documentElement.clientWidth - contentWidth;
        }
    }
    return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        width: matchTriggerWidth && (finalPlacement === 'top' || finalPlacement === 'bottom')
            ? "".concat(triggerRect.width, "px")
            : 'auto',
    };
};
export var determineOptimalPlacement = function (placement, alignment, placementFallback, triggerRect, contentHeight, contentWidth) {
    // If forced, just return the placement and alignment
    if (placementFallback !== 'auto') {
        return {
            finalPlacement: getForcedPlacement(placementFallback, placement),
            finalAlignment: alignment,
        };
    }
    var viewportHeight = window.innerHeight;
    var viewportWidth = window.innerWidth;
    var spaceBelow = viewportHeight - triggerRect.bottom;
    var spaceAbove = triggerRect.top;
    var spaceRight = viewportWidth - triggerRect.right;
    var spaceLeft = triggerRect.left;
    // These 2 blocks ensures that content is visible on the page, by testing all placement/alignment combinations
    if (placement === 'left' || placement === 'right') {
        // For each alignment, calculate the resulting top position
        var startTop = triggerRect.top;
        var centerTop = triggerRect.top + (triggerRect.height - contentHeight) / 2;
        var endTop = triggerRect.bottom - contentHeight;
        // Check if each alignment would fit vertically
        var startFits = startTop >= 0 && startTop + contentHeight <= viewportHeight;
        var centerFits = centerTop >= 0 && centerTop + contentHeight <= viewportHeight;
        var endFits = endTop >= 0 && endTop + contentHeight <= viewportHeight;
        // If current alignment doesn't fit but others do, switch to the one that fits
        if (alignment === 'start' && !startFits) {
            if (centerFits) {
                return { finalPlacement: placement, finalAlignment: 'center' };
            }
            if (endFits) {
                return { finalPlacement: placement, finalAlignment: 'end' };
            }
        }
        else if (alignment === 'center' && !centerFits) {
            if (endFits) {
                return { finalPlacement: placement, finalAlignment: 'end' };
            }
            if (startFits) {
                return { finalPlacement: placement, finalAlignment: 'start' };
            }
        }
        else if (alignment === 'end' && !endFits) {
            if (centerFits) {
                return { finalPlacement: placement, finalAlignment: 'center' };
            }
            if (startFits) {
                return { finalPlacement: placement, finalAlignment: 'start' };
            }
        }
        // If no alignment fits, try changing placement
        if (!startFits && !centerFits && !endFits) {
            if (placement === 'right' && spaceLeft > contentWidth) {
                return { finalPlacement: 'left', finalAlignment: alignment };
            }
            if (placement === 'left' && spaceRight > contentWidth) {
                return { finalPlacement: 'right', finalAlignment: alignment };
            }
            // If horizontal placements won't work, try vertical
            return {
                finalPlacement: spaceBelow > spaceAbove ? 'bottom' : 'top',
                finalAlignment: 'start',
            };
        }
    }
    if (placement === 'top' || placement === 'bottom') {
        // For each alignment, calculate the resulting left position
        var startLeft = triggerRect.left;
        var centerLeft = triggerRect.left + (triggerRect.width - contentWidth) / 2;
        var endLeft = triggerRect.right - contentWidth;
        // Check if each alignment would fit horizontally
        var startFits = startLeft >= 0 && startLeft + contentWidth <= viewportWidth;
        var centerFits = centerLeft >= 0 && centerLeft + contentWidth <= viewportWidth;
        var endFits = endLeft >= 0 && endLeft + contentWidth <= viewportWidth;
        // If current alignment doesn't fit but others do, switch to the one that fits
        if (alignment === 'start' && !startFits) {
            if (centerFits) {
                return { finalPlacement: placement, finalAlignment: 'center' };
            }
            if (endFits) {
                return { finalPlacement: placement, finalAlignment: 'end' };
            }
        }
        else if (alignment === 'center' && !centerFits) {
            if (endFits) {
                return { finalPlacement: placement, finalAlignment: 'end' };
            }
            if (startFits) {
                return { finalPlacement: placement, finalAlignment: 'start' };
            }
        }
        else if (alignment === 'end' && !endFits) {
            if (centerFits) {
                return { finalPlacement: placement, finalAlignment: 'center' };
            }
            if (startFits) {
                return { finalPlacement: placement, finalAlignment: 'start' };
            }
        }
        // If no alignment works, check if we need to change vertical placement
        if ((!startFits && !centerFits && !endFits) ||
            (placement === 'bottom' && spaceBelow < contentHeight && spaceAbove > contentHeight) ||
            (placement === 'top' && spaceAbove < contentHeight && spaceBelow > contentHeight)) {
            if (placement === 'bottom' && spaceAbove > contentHeight) {
                return { finalPlacement: 'top', finalAlignment: alignment };
            }
            if (placement === 'top' && spaceBelow > contentHeight) {
                return { finalPlacement: 'bottom', finalAlignment: alignment };
            }
            // If vertical placements won't work, try horizontal
            return {
                finalPlacement: spaceRight > spaceLeft ? 'right' : 'left',
                finalAlignment: 'start',
            };
        }
    }
    // Check if the current placement needs to be flipped regardless of alignment
    if (placement === 'bottom' && spaceBelow < contentHeight && spaceAbove > contentHeight) {
        return { finalPlacement: 'top', finalAlignment: alignment };
    }
    if (placement === 'top' && spaceAbove < contentHeight && spaceBelow > contentHeight) {
        return { finalPlacement: 'bottom', finalAlignment: alignment };
    }
    if (placement === 'right' && spaceRight < contentWidth && spaceLeft > contentWidth) {
        return { finalPlacement: 'left', finalAlignment: alignment };
    }
    if (placement === 'left' && spaceLeft < contentWidth && spaceRight > contentWidth) {
        return { finalPlacement: 'right', finalAlignment: alignment };
    }
    return { finalPlacement: placement, finalAlignment: alignment };
};
